// Selected residential project photographs. Replace `image` URLs as updated photos arrive; keep the ids stable.
export const galleryPage = {
  hero: {
    eyebrow: 'Selected residential landscapes',
    title: 'Find inspiration in the details.',
    intro:
      'Explore a selection of gardens, hardscapes and outdoor spaces from D.A. Alexander. See how planting, paths and places to gather come together around a home.',
    primary: { label: 'Discuss your landscape', href: '/contact' },
  },
  projects: [
    {
      id: 'northville',
      location: 'Northville',
      caption: 'Stone steps & woodland planting.',
      image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/northville-logo-cleaned-20261029.png',
      alt: 'Stone steps, boulders and a garden path beside a wooded home in Northville.',
    },
    {
      id: 'canton',
      location: 'Canton',
      caption: 'A welcoming paver entry.',
      image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/canton-logo-cleaned-20261029.png',
      alt: 'A paver entry walk and planting beds in front of a brick home in Canton.',
    },
    {
      id: 'plymouth',
      location: 'Plymouth',
      caption: 'A garden beneath mature trees.',
      image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/plymouth-logo-cleaned-20261029.png',
      alt: 'Hydrangeas, hostas and mature trees in a residential garden in Plymouth.',
    },
  ],
  recognition: {
    title: 'Recognized residential work.',
    text: 'View the award recognition associated with selected D.A. Alexander landscapes.',
    action: { label: 'Explore award-winning projects', href: '/awards' },
  },
  closing: {
    title: 'What would you like to enjoy outside?',
    text: 'Explore our residential landscape services, or tell us about your property and the ideas you have in mind.',
    action: { label: 'Residential landscapes & outdoor living', href: '/residential-landscapes' },
    secondaryAction: { label: 'Start your project', href: '/contact' },
  },
};

export type GalleryProject = (typeof galleryPage.projects)[number];
